import { useTenant } from '../auth/TenantContext';

/**
 * Returns the active tenant slug for use as a query-key segment, so tenant-scoped
 * queries are cached per tenant and don't show another tenant's data while
 * switching. `''` until a tenant resolves.
 */
export function useTenantKey(): string {
  const { activeTenant } = useTenant();
  return activeTenant?.slug ?? '';
}
